var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcGreenDownload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 414"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 305",
    style: {
      fill: "none"
    },
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 413"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 185",
    d: "M17.728 26.712a1.161 1.161 0 0 0-1.161 1.161v3.28a1.162 1.162 0 0 1-1.161 1.161H3.483a1.162 1.162 0 0 1-1.161-1.161v-3.28a1.161 1.161 0 0 0-2.322 0v3.28a3.486 3.486 0 0 0 3.483 3.483h11.923a3.486 3.486 0 0 0 3.483-3.483v-3.28a1.161 1.161 0 0 0-1.161-1.161",
    transform: "translate(.556 -14.973)",
    style: {
      fill: "#00a61c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 186",
    d: "M13.341 14.925a1.161 1.161 0 0 0 1.641 0l4.194-4.194a1.161 1.161 0 1 0-1.641-1.641l-2.213 2.21V1.161a1.161 1.161 0 0 0-2.322 0V11.3l-2.212-2.211a1.161 1.161 0 0 0-1.641 1.641z",
    transform: "translate(-4.161 .336)",
    style: {
      fill: "#00a61c"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGreenDownload);
export default __webpack_public_path__ + "static/media/ic-green-download.49ac3c8595fcbc05fa059ca2590cf285.svg";
export { ForwardRef as ReactComponent };